module.exports = __webpack_public_path__ + "images/category_lp/car/assessment_achievements/6@2x_187a1259eeb6f7716d807f3de6a895a9.png";